import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Check from '@hellodarwin/icons/dist/icons/Check';
import Refereral from '@hellodarwin/icons/dist/icons/Refereral';
import Refresh from '@hellodarwin/icons/dist/icons/Refresh';
import TabArrow from '@hellodarwin/icons/dist/icons/TabArrow';
import { useTheme } from 'styled-components';
import { useGinSteps } from '../gin-steps-provider';
import Button from '@hellodarwin/core/lib/components/common/button';
import Avatar from 'antd/es/avatar';
const GinPageHeader = ({ pageIndex, pageId, titleEn, titleFr, formFillingPageState, isGenerationAllowed, pageStepsText, pageNumberText, grantId, onGeneratePage, isGeneratingPage, openPromptDrawer, }) => {
    var _a;
    const theme = useTheme();
    const { formState, viewMode } = useGinSteps();
    const isAdminView = viewMode === 'admin_fr' || viewMode === 'admin_en';
    const displayedTitle = isAdminView
        ? viewMode === 'admin_en'
            ? titleEn
            : titleFr
        : viewMode === 'client_en'
            ? titleEn
            : titleFr;
    return (_jsxs(Div, { flex: "row", align: "center", gap: 12, children: [_jsxs(Div, { flex: "row", align: "center", gap: 12, children: [(formState === 'filling' || formState === 'viewing') &&
                        formFillingPageState && (_jsx(Div, { style: {
                            width: 24,
                            height: 24,
                            borderRadius: 20,
                            border: '1px solid ' +
                                (formFillingPageState.isPageCompleted
                                    ? theme.colors.green_1
                                    : formFillingPageState.isPageInProgress
                                        ? theme.colors.purple_2
                                        : theme.colors.grey_4),
                            backgroundColor: formFillingPageState.isPageCompleted
                                ? theme.colors.green_4
                                : formFillingPageState.isPageInProgress
                                    ? theme.colors.purple_4
                                    : theme.colors.grey_5,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            minWidth: '24px',
                            minHeight: '24px',
                        }, children: formFillingPageState.isPageCompleted ? (_jsx(Check, { size: 10, color: theme.colors.grey_1 })) : formFillingPageState.isPageInProgress && isAdminView ? (_jsx(TabArrow, { size: 10, color: theme.colors.purple_1, style: {
                                transform: 'rotate(90deg)',
                            } })) : (_jsx(_Fragment, {})) })), _jsxs(Div, { flex: "column", align: "left", gap: 8, children: [_jsxs(Div, { flex: "row", align: "center", gap: 12, children: [_jsxs(Div, { flex: "column", align: "left", gap: 2, children: [_jsx(Typography, { elementTheme: "body3", color: theme.colors.grey_1, style: {
                                                    fontFamily: 'Inter',
                                                    fontWeight: 400,
                                                    fontSize: 14,
                                                }, children: pageNumberText }), _jsx(Typography, { style: {
                                                    color: theme.colors.grey_1,
                                                    fontFamily: 'Inter',
                                                    fontWeight: 500,
                                                    fontSize: 18,
                                                }, elementTheme: "subtitle2", children: displayedTitle })] }), isGenerationAllowed && (_jsxs(Div, { flex: "row", gap: 8, style: { width: 120 }, children: [_jsx(Button, { size: "square", defaultStyle: theme.colors.white_1, onClick: () => {
                                                    openPromptDrawer === null || openPromptDrawer === void 0 ? void 0 : openPromptDrawer(pageIndex);
                                                }, trailingIcon: _jsx(Refereral, { size: 20 }) }), _jsx(Button, { size: "square", defaultStyle: theme.colors.purple_1, loading: isGeneratingPage, disabled: isGeneratingPage, onClick: () => {
                                                    onGeneratePage === null || onGeneratePage === void 0 ? void 0 : onGeneratePage(pageId, pageIndex, grantId);
                                                }, trailingIcon: _jsx(Refresh, { size: 20 }) })] }))] }), (isAdminView ||
                                formState === 'filling' ||
                                formState === 'viewing') && (_jsx(Typography, { elementTheme: "overline", color: theme.colors.grey_2, style: {
                                    fontFamily: 'Inter',
                                    fontWeight: 500,
                                    fontSize: 11,
                                    textTransform: 'uppercase',
                                }, children: pageStepsText }))] })] }), isAdminView &&
                (formState === 'filling' || formState === 'viewing') &&
                !!((_a = formFillingPageState === null || formFillingPageState === void 0 ? void 0 : formFillingPageState.pageAdmins) === null || _a === void 0 ? void 0 : _a.length) && (_jsx(Div, { flex: "row", align: "right", justify: "end", style: { maxWidth: '68px' }, children: formFillingPageState.pageAdmins.map((admin, index) => (_jsx(Div, { style: {
                        width: '28px',
                        height: '28px',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: index > 0 ? '-8px' : 0,
                        zIndex: 10 - index,
                    }, children: _jsx(Avatar, { src: admin === null || admin === void 0 ? void 0 : admin.picture, style: {
                            width: '28px !important',
                            height: '28px !important',
                            border: '1px solid ' + theme.colors.grey_5,
                        } }) }, admin === null || admin === void 0 ? void 0 : admin.admin_id))) }))] }));
};
export default GinPageHeader;
